import { ApiProperty } from '@nestjs/swagger';
import { IsNumber } from 'class-validator';

export class PlantInvoiceDetailsRequest {
    @ApiProperty()
    @IsNumber()
    saleOrderId?: number;


    /**
     * @param saleOrderId
    */
    constructor(saleOrderId?: number){
       this.saleOrderId=saleOrderId;
    }
}    